
import AudioGroupViewModel from "@models/meditations/create/audioGroupViewModel";
import MeditationAudioViewModel from "@models/meditations/create/meditationAudioViewModel";
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class AddAudioGroupComponent extends Vue {  
  @Prop({type: Boolean, default: true}) audioRequired: boolean;
  @Prop({type: Boolean, default: false}) enableSpeech: boolean;
  @Prop({type: Boolean, default: false}) showDescription: boolean;
  @Prop({type: Boolean, default: false}) allowPartialLocales: boolean;
  @Prop({type: Object}) audioGroup: AudioGroupViewModel;
  @Prop({default: false}) edit: boolean;
  currentAudioGroup: AudioGroupViewModel = null;
  currentAudioGroupIsPaid = false;
  @Watch('audioGroup')
  onChangeAudioGroup() {    
    this.currentAudioGroup = this.audioGroup == null ? null : this.audioGroup.clone();
    this.currentAudioGroupIsPaid = this.currentAudioGroup ? this.currentAudioGroup.isPaid : false;
  }
  @Watch('edit')
  editUpdate(newValue: boolean) {
    if(newValue) {
      this.currentAudioGroup = this.audioGroup == null ? null : this.audioGroup.clone();
      this.currentAudioGroupIsPaid = this.currentAudioGroup ? this.currentAudioGroup.isPaid : false;
    }
  }
  setCurrentAudioGroupIsPaid(value: boolean) {
    this.currentAudioGroupIsPaid = value;
    this.applyPaidStateToAudioGroup();
  }
  applyPaidStateToAudioGroup() {
    if (!this.currentAudioGroup) {
      return;
    }
    this.currentAudioGroup.isPaid = this.currentAudioGroupIsPaid;
    (this.currentAudioGroup.audios || []).forEach((item) => {
      item.isPaid = this.currentAudioGroupIsPaid;
    });
  }
  removeAudio(item: MeditationAudioViewModel) {
    if (!this.enableSpeech) item.id = null;
    item.audioFile = null;
    item.base64File = null;
    item.audioUrl = null;
  }
  hasAudioLocaleContent(item: MeditationAudioViewModel): boolean {
    return !!(
      item &&
      (
        item.id ||
        item.audioFile ||
        item.base64File ||
        item.audioUrl ||
        (item.name || "").trim() ||
        (item.description || "").trim()
      )
    );
  }
  normalizeCurrentAudioGroup() {
    if (!this.currentAudioGroup || !this.allowPartialLocales) {
      return;
    }
    this.currentAudioGroup.audios = (this.currentAudioGroup.audios || []).filter((item) =>
      this.hasAudioLocaleContent(item)
    );
  }
  emit() {
    this.applyPaidStateToAudioGroup();
    this.$emit('change', this.currentAudioGroup);
  }
  cancelAddAudio() {
    this.currentAudioGroup = null;
    this.emit();
  }
  async onOkAudioModal() {
    const isValid = (this.$refs.audioValidator as any).isValid();
    if (!isValid) return;
    if (this.enableSpeech && (this.currentAudioGroup.audios || []).some((item) =>
      item.generateAudio && !(item.description || '').trim())) {
      this.$notification.error('Для озвучки заполните описание фразы');
      return;
    }
    await Promise.all(
      (this.currentAudioGroup?.audios || []).map((item) => item.ensureAudioFileReady())
    );
    this.applyPaidStateToAudioGroup();
    this.normalizeCurrentAudioGroup();
    if (
      this.allowPartialLocales &&
      (!this.currentAudioGroup || !(this.currentAudioGroup.audios || []).length)
    ) {
      this.$notification.error("Добавьте хотя бы одну языковую версию");
      return;
    }
    this.emit();
    this.currentAudioGroup = null;
  }
}
